import React from 'react';
import axios from 'helpers/axios';

import { Container, Title, TextInput, Button, Form, Image, Label } from 'ui/components/styled';
import { AuthLayout } from 'ui/components/layouts';
import { useUser, useToasts, useLayout } from 'hooks';
import { ValidationPattern } from 'helpers/form';
import { CloseButton } from 'ui/components/shared';

export const TFASMS = () => {
  const [phone, setPhone] = React.useState('');
  const { setLayoutLoading } = useLayout();
  const { user, challenges, signOut, redirectTo } = useUser();
  const { errorToast } = useToasts();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user.phone) {
      errorToast(
        <>
          No phone number associated with the current user!
          <br /> Please contact support for more details.
        </>
      );
      return;
    } else if (phone !== user.phone) {
      errorToast(
        <>
          Phone number is wrong!
          <br /> Please contact support to change it.
        </>
      );
      return;
    }
    try {
      setLayoutLoading(true);
      const response = await axios.get('/challenges/sms/send');
      if (response.status === 200) {
        redirectTo('/2fa/sms/verify');
        return;
      }
    } catch (error) {
      errorToast({ error, default: 'Error: 2FA SMS verify.' });
    }
    setLayoutLoading(false);
  };

  return (
    <AuthLayout show={challenges.required} justifyContent="start">
      <Container width="80%" maxWidth="480px" height="auto" top="15%">
        <Container alignItems="center" mb="xl">
          <Image alt="2FA" src="/assets/img/2FA.png" />
        </Container>
        <Title mb="m">Two-step verification</Title>
        <Title type="h3" variant="grey" mb="m">
          Please validate your phone number
        </Title>
        <Form onSubmit={handleSubmit}>
          <Container>
            <Label htmlFor="phone" mb="xs">
              Phone number
            </Label>
            <TextInput
              id="phone"
              name="phone"
              type="tel"
              pattern={ValidationPattern.phone}
              placeholder={`(xxx)-xxx-xx${(user.phone || '').slice(-2)}`}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              autoFocus
            />
          </Container>
          <Button type="submit" my="m">
            Send SMS
          </Button>
        </Form>
      </Container>
      <CloseButton title="Logout" onClick={signOut} />
    </AuthLayout>
  );
};
